import { erc20Abi, BSC_TOKENS } from "const/profile/token";
import { formatUnits } from "viem";
import { useAccount, useBalance, useReadContracts } from "wagmi";
import { bsc } from "wagmi/chains";
var TOKEN_DECIMALS = {
    QUANTA: 12,
};
export var useBalances = function () {
    var _a = useAccount(), address = _a.address, isConnected = _a.isConnected;
    var bnb = useBalance({
        address: address,
        chainId: bsc.id,
    });
    var erc20Keys = Object.keys(BSC_TOKENS).filter(function (key) { return key !== "BNB"; });
    // ERC20 контракты
    var contracts = erc20Keys.map(function (key) { return ({
        address: BSC_TOKENS[key],
        abi: erc20Abi,
        functionName: "balanceOf",
        args: [address],
        chainId: bsc.id,
    }); });
    var erc20Balances = useReadContracts({
        contracts: contracts,
        query: {
            enabled: !!address,
        },
    });
    // helper для безопасного форматирования
    var formatResult = function (res, decimals) {
        if (decimals === void 0) { decimals = 18; }
        if (!res)
            return 0;
        var value;
        if (typeof res === "bigint")
            value = res;
        else if (typeof res === "number")
            value = BigInt(res);
        else
            return 0;
        return Number(formatUnits(value, decimals));
    };
    var balances = {
        BNB: bnb.data ? Number(formatUnits(bnb.data.value, bnb.data.decimals)) : 0,
    };
    if (erc20Balances.data) {
        erc20Keys.forEach(function (tokenKey, index) {
            var _a;
            var decimals = TOKEN_DECIMALS[tokenKey] || 18;
            balances[tokenKey] = formatResult((_a = erc20Balances.data[index]) === null || _a === void 0 ? void 0 : _a.result, decimals);
        });
    }
    return {
        isConnected: isConnected,
        address: address,
        balances: balances,
        isLoading: bnb.isLoading || erc20Balances.isLoading,
    };
};
